// import { desformata } from '@/shared/tools/tools';
// import { eventos, emitter } from '../../../../shared/emitter/emitter';
// import files from '@/shared/files/files';
import { emitter, eventos } from '@/shared/emitter/emitter';
//import files from '@/shared/files/files';
// import files from '@/shared/files/files';
import { desformata } from '@/shared/services/tools';


export default class PesquisaCabecalho extends HTMLElement {
  constructor(mostraIcone = false, campoBusca = false, limpaFormatacao = false){
    super();
    let container = document.createElement('div');
    this.limpaFormatacao = limpaFormatacao;

    if(mostraIcone){

      let inputText = document.createElement('input')
      inputText.type = 'text';
      inputText.style.backgroundColor = 'transparent';
      inputText.style.width = '60%';
      inputText.classList.add('input-text-busca-cabecalho')

      inputText.oninput = () => {
        if(typeof campoBusca === 'string'){
          this.emitir([{
            campo: campoBusca,
            valor: inputText.value,
          }])
          return;
        }
      };

      let imgIcone = document.createElement('img');
      imgIcone.src = require('../../../assets/imgs/search.svg')
      // files.retornaUrlImagem('search.svg');
      imgIcone.style.width = '20px';
      console.log(imgIcone)

      imgIcone.onclick = () => {inputText.focus()}

      container.append(imgIcone);
      container.append(inputText);
      container.style.display = 'flex'
      container.style.gap = '0.5rem'
      this.append(container);

    }
    this.classList.add('flex', 'items-center', 'justify-start', 'w-full', 'h-full');
    this.style.display = 'flex';
    this.style.alignItems = 'center';
    this.style.justifyContent = 'start';
    this.style.height = '100%';
    this.style.width = '100%';
    this.style.backgroundColor = '#f9f9f9';
    this.style.height = '40px';
    this.style.paddingLeft = '10px';
    this.style.borderTop = '1px solid #e2e2e2';
  }

  emitir(campos = []){
    if(this.limpaFormatacao) campos.forEach(x => x.valor = this._limpaFormatacao(x.valor));
    emitter.emit(eventos.buscaCabecalho, campos)
  }

  _limpaFormatacao(valor){
    return desformata(valor)
  }

}

customElements.define('pesquisa-cabecalho', PesquisaCabecalho);
